import React, { PropsWithChildren } from 'react';
import { useIsGuest } from './GuestProvider';

export const HideForGuests = ({ children }: PropsWithChildren<{}>) => {
  const isGuest = useIsGuest();

  return isGuest ? null : <>{children}</>;
};
